import { render } from "./AudioRecorder.vue?vue&type=template&id=b7fee65a"
import script from "./AudioRecorder.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AudioRecorder.vue?vue&type=script&charset=utf-8&lang=js"

import "./AudioRecorder.vue?vue&type=style&index=0&id=b7fee65a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__